import Bold from "@tiptap/extension-bold";

declare module "@tiptap/core" {
	interface Commands<ReturnType> {
		bold_strong: {
			setBold_strong:    () => ReturnType;
			toggleBold_strong: () => ReturnType;
			unsetBold_strong:  () => ReturnType;
		};
	}
}

// Preserve <strong> tags for bold
export const CustomBold_strong = Bold.extend({
	name: "bold_strong",
	addCommands() {
		return {
			setBold_strong: () => ({commands}) => {
				return commands.setMark("bold_strong");
			},
			toggleBold_strong: () => ({commands}) => {
				return commands.toggleMark("bold_strong");
			},
			unsetBold_strong: () => ({commands}) => {
				return commands.unsetMark("bold_strong");
			}
		};
	},
	parseHTML() {
		return [{
			tag: "strong"
		}];
	}
});
